import React from "react";
import * as Mui from "@mui/material";
import { DialogFrame } from "component/shared/dialog-frame";
import { OutlinedButton } from "component/shared/outlined-button";

interface FrameProps {
	open: boolean;
	// "Fix MLS ID" unless the fix has its own.
	title?: string;
	titleId: string;
	saveLabel: string;
	saving: boolean;
	error: string | null;
	onSave: () => void;
	onClose: () => void;
	// An action on the left of the buttons, such as Remove All.
	leadingAction?: React.ReactNode;
	children: React.ReactNode;
}

export const FixFrame: React.FC<FrameProps> = ({ open, title = "Fix MLS ID", titleId, saveLabel, saving, error, onSave, onClose, leadingAction, children }) => (
	<DialogFrame
		open={open}
		onClose={onClose}
		title={title}
		titleId={titleId}
		closeDisabled={saving}
		notice={error && <Mui.Alert severity="error">{error}</Mui.Alert>}
		actions={
			<>
				{leadingAction}
				<OutlinedButton onClick={onClose} disabled={saving}>Cancel</OutlinedButton>
				<Mui.Button variant="contained" color="primary" onClick={onSave} disabled={saving}>{saveLabel}</Mui.Button>
			</>
		}
	>
		{children}
	</DialogFrame>
);
